export default __webpack_public_path__ + "static/media/flag-LV.c9044332.svg";